<template>
  <div ref="event" class="event-item">
    <div class="event-item__content">
      <span v-if="fullSchedule" class="event-item__schedule">{{ fullSchedule }}</span>
      <span v-if="title" class="event-item__title">{{ title }}</span>
      <span v-if="address" class="event-item__address">{{ address }}</span>
    </div>
    <a v-if="link" :href="link" class="event-item__btn">{{ $t('events_btn_text') }}</a>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { transliteration } from '../../mixins/transliteration'

export default {
  name: 'EventsSliderItem',
  mixins: [transliteration],
  props: {
    address: {
      type: String,
      default: ''
    },
    shortDescription: {
      type: String,
      default: ''
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    blockName: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language
    }),
    computedDate () {
      if (this.language && this.startDate && this.endDate) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        const start = new Date(this.startDate).toLocaleDateString(this.language, options).split(' ')
        const end = new Date(this.endDate).toLocaleDateString(this.language, options).split(' ')

        const startDay = start[0]
        const startMonth = start[1]
        const startYear = start[2]
        const endDay = end[0]
        const endMonth = end[1]
        const endYear = end[2]

        if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
          return startDay + ' ' + startMonth + ' ' + startYear
        } else if (startDay !== endDay && startMonth === endMonth && startYear === endYear) {
          return this.$t('events_time_from') + ' ' + startDay + ' ' + this.$t('events_time_to') + ' ' + endDay + ' ' + startMonth + ' ' + startYear
        } else if (startMonth !== endMonth && startYear === endYear) {
          return this.$t('events_time_from') + ' ' + startDay + ' ' + startMonth + ' ' + this.$t('events_time_to') + ' ' + endDay + ' ' + endMonth + ' ' + startYear
        } else {
          return this.$t('events_time_from') + ' ' + startDay + ' ' + startMonth + ' ' + startYear + ' ' + this.$t('events_time_to') + ' ' + endDay + ' ' + endMonth + ' ' + endYear
        }
      }

      return ''
    },
    computedTime () {
      if (this.startTime && this.endTime) {
        return this.startTime + '-' + this.endTime
      }

      return ''
    },
    fullSchedule () {
      if (this.computedDate && this.computedTime) {
        return this.computedDate + ' | ' + this.computedTime
      } else if (this.computedDate) {
        return this.computedDate
      }

      return ''
    }
  },
  methods: {
    ...mapActions(['SET_PROMOTIONS_IN_VIEW_PORT_ACTION', 'SEND_CLICKED_PROMOTION']),
    async handleRedirect (e, link) {
      e.preventDefault()

      await this.SEND_CLICKED_PROMOTION({
        'name': this.transliterate(this.title),
        'creative': this.transliterate(this.blockName),
        'position': 'slot' + this.position
      })

      location.href = link
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.SET_PROMOTIONS_IN_VIEW_PORT_ACTION({
          'name': this.transliterate(this.title),
          'creative': this.transliterate(this.blockName),
          'position': 'slot' + this.position
        })

        observer.unobserve(this.$refs.event)
      }
    })
    setTimeout(() => {
      observer.observe(this.$refs.event)
    }, 0)
  }
}
</script>

<style scoped lang="sass">

.event-item
  display: flex
  flex-flow: column
  border: 1px solid $nd-border-color
  border-radius: 3px
  padding: 0 10px 10px
  background-color: $white-text-color
  height: 100%
  box-sizing: border-box

  +mmin($tablet)
    padding: 0 10px 15px

.event-item__content
  padding: 10px 10px 30px

  +mmin($tablet)
    padding: 30px 25px

.event-item__schedule
  display: block
  font-size: 10px
  color: $placeholder-color
  margin: 0 0 15px

  +mmin($tablet)
    font-size: 14px
    margin: 0 0 10px

.event-item__title
  display: block
  font-size: 16px
  font-weight: 500
  margin: 0 0 10px

  +mmin($tablet)
    font-size: 18px
    margin: 0 0 20px

.event-item__address
  display: block
  font-size: 12px
  color: $placeholder-color

  +mmin($tablet)
    font-size: 14px

.event-item__btn
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  padding: 11px 0
  background-color: $nd-border-color
  border-radius: 3px
  font-size: 12px
  font-weight: 500
  color: $text-color
  margin: auto 0 0

  +mmin($tablet)
    font-size: 14px

</style>
